import * as React from 'react';
import cx from 'classnames';

import { Text } from 'components/typography';
import { TextSizes } from 'components/typography/text';

type SkipLinkProps = {
  to: string;
  className?: string;
  size?: TextSizes;
  unstyled?: boolean;
};

const SkipLink = ({
  to,
  className = '',
  size = 'l',
  children,
  unstyled,
  ...otherProps
}: SkipLinkProps & React.HTMLAttributes<HTMLAnchorElement>) => {
  const renderSkipLink = () => {
    const skipLinkClasses = cx('sr-only font-bold focus:not-sr-only', {
      [className]: unstyled
    });
    return (
      <Text
        tagName="a"
        size={size}
        className={skipLinkClasses}
        {...{ href: to }}
        {...otherProps}
      >
        {children}
      </Text>
    );
  };
  return unstyled ? (
    renderSkipLink()
  ) : (
    <div className={`relative -top-8 ${className}`}>
      <div className="absolute w-max">{renderSkipLink()}</div>
    </div>
  );
};

export default SkipLink;
